import {
    getApiPublicQueueStreamQueryKey,
    usePostApiBookingParallel,
    usePostApiBookingSequential,
    usePostApiBookingSingle,
} from '@barbershop/api/customer'
import { useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { getErrorCode, getErrorMessage } from '@/shared/config'

export const useCreateBooking = () => {
    const queryClient = useQueryClient()

    const mutationOptions = {
        onSuccess: async (_data: unknown, { params }: { params: { branch_id: number } }) => {
            await Promise.all([
                queryClient.invalidateQueries({
                    queryKey: getApiPublicQueueStreamQueryKey({ branch_id: params.branch_id }),
                }),
                queryClient.invalidateQueries({
                    predicate: ({ queryKey }) => JSON.stringify(queryKey).includes('slots'),
                }),
            ])
        },
        onError: (error: unknown) => {
            if (getErrorCode(error) === 1010) {
                void queryClient.invalidateQueries({
                    predicate: ({ queryKey }) => JSON.stringify(queryKey).includes('slots'),
                })
            }

            toast.error(`Ошибка при создании записи. ${getErrorMessage(getErrorCode(error))}`)
        },
    }

    const { mutateAsync: createSingleBooking, isPending: isSingleBookingPending } =
        usePostApiBookingSingle({
            mutation: mutationOptions,
        })
    const { mutateAsync: createParallelBooking, isPending: isParallelBookingPending } =
        usePostApiBookingParallel({
            mutation: mutationOptions,
        })
    const { mutateAsync: createSequentialBooking, isPending: isSequentialBookingPending } =
        usePostApiBookingSequential({
            mutation: mutationOptions,
        })

    return {
        createParallelBooking,
        createSequentialBooking,
        createSingleBooking,
        isPending: isSingleBookingPending || isParallelBookingPending || isSequentialBookingPending,
    }
}
